"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isNaviTVLDataStale = void 0;
exports.cacheNaviTVL = cacheNaviTVL;
exports.getAllPoolsNaviTVL = getAllPoolsNaviTVL;
exports.fetchTVLFromNavi = fetchTVLFromNavi;
const client_dynamodb_1 = require("@aws-sdk/client-dynamodb");
const alphafi_sdk_1 = require("@alphafi/alphafi-sdk");
const dynamoDbClient = new client_dynamodb_1.DynamoDBClient({});
const TABLE_NAME = process.env.NAVI_PARAMS_TABLE_NAME;
async function cacheNaviTVL(naviPoolTVLObject) {
    const params = {
        TableName: TABLE_NAME,
        Item: {
            naviPoolTVL: { S: naviPoolTVLObject.naviPoolTVL },
            poolName: { S: naviPoolTVLObject.poolName },
            lastUpdated: { N: naviPoolTVLObject.lastUpdated.toString() },
        },
    };
    await dynamoDbClient.send(new client_dynamodb_1.PutItemCommand(params));
}
async function getAllPoolsNaviTVL() {
    const params = {
        TableName: TABLE_NAME,
    };
    const result = await dynamoDbClient.send(new client_dynamodb_1.ScanCommand(params));
    const resultItems = result.Items
        ? result.Items.map((item) => ({
            naviPoolTVL: item.naviPoolTVL?.S,
            poolName: item.poolName?.S,
            lastUpdated: item.lastUpdated?.N
                ? parseInt(item.lastUpdated.N, 10)
                : undefined,
        })).filter((item) => item.naviPoolTVL !== undefined &&
            item.poolName !== undefined &&
            item.lastUpdated !== undefined)
        : [];
    return resultItems;
}
const formatNavCoinType = (naviCoinType) => {
    if (naviCoinType ===
        "0000000000000000000000000000000000000000000000000000000000000002::sui::SUI") {
        return "0x2::sui::SUI";
    }
    return `0x${naviCoinType}`;
};
async function fetchTVLFromNavi() {
    const options = {
        method: "GET",
        headers: {
            accept: "application/json",
        },
    };
    try {
        const req_url = "https://open-api.naviprotocol.io/api/navi/pools";
        const res = await fetch(req_url, options);
        if (!res.ok) {
            throw new Error(`HTTP error in naviprotocol! status: ${res.status}`);
        }
        const data = await res.json();
        const naviPoolObjectArray = data.data;
        const naviPoolDBObjectArray = [];
        // check all the pools that are navi and make entry in the array
        const requiredPools = Object.entries(alphafi_sdk_1.poolInfo).filter(([_, poolInfo]) => poolInfo.parentProtocolName === "NAVI");
        for (const [poolName, poolInfo] of requiredPools) {
            const naviPool = naviPoolObjectArray.find((naviPoolObject) => formatNavCoinType(naviPoolObject.coinType) ===
                poolInfo.naviParentPoolCoinType);
            if (!naviPool) {
                continue;
            }
            naviPoolDBObjectArray.push({
                poolName,
                lastUpdated: Date.now(),
                naviPoolTVL: (((parseFloat(naviPool.totalSupplyAmount) -
                    parseFloat(naviPool.borrowedAmount)) *
                    parseFloat(naviPool.oracle.price)) /
                    1e9).toString(),
            });
        }
        return naviPoolDBObjectArray;
    }
    catch (error) {
        console.error(error);
    }
    return [];
}
const isNaviTVLDataStale = (lastUpdated) => {
    const ttl = 3600000; // TTL in milliseconds (1 minute)
    return Date.now() > lastUpdated + ttl;
};
exports.isNaviTVLDataStale = isNaviTVLDataStale;
//# sourceMappingURL=ext_api.js.map